// extracted by mini-css-extract-plugin
module.exports = {"button":"C_cg","button__primary":"C_ch","button__red":"C_cj","button__secondary":"C_ck","button__secondary__white":"C_cl","button__tertiary":"C_cm"};